export class Eligibility {
	showDisability: boolean;
	showTitleXIX: boolean;
	showSpouseCoverage: boolean;
	showMedical: boolean;
	disabilityQuestionForDisplay: string;
	titleXIXQuestionForDisplay: string;
	spouseQuestionForDisplay: string;
	medicalQuestionForDisplay: string;
	disabilityCollection: EligibilityQuestion[];
	titleXIXCollection: EligibilityQuestion[];
	spouseCoverageCollection: EligibilityQuestion[];
	medicalCollection: EligibilityQuestion[];

	constructor() {
		this.showDisability = false;
		this.showTitleXIX = false;
		this.showSpouseCoverage = false;
		this.showMedical = false;
		this.disabilityQuestionForDisplay = null;
		this.titleXIXQuestionForDisplay = null;
		this.spouseQuestionForDisplay = null;
		this.medicalQuestionForDisplay = null;
		this.disabilityCollection = new Array<EligibilityQuestion>();
		this.titleXIXCollection = new Array<EligibilityQuestion>();
		this.spouseCoverageCollection = new Array<EligibilityQuestion>();
		this.medicalCollection = new Array<EligibilityQuestion>();
	}
}

export class EligibilityQuestion {
	knockoutDependentID: string;
	coveredMemberName: string;
	relationship: string;
	isYesResponse: boolean;

	constructor() {
		this.knockoutDependentID = null;
		this.coveredMemberName = null;
		this.relationship = null;
		this.isYesResponse = null;
	}
}

export class EligibilityGrid {
	title: string;
	question: string;
	collection: EligibilityQuestion[];

	constructor() {
		this.title = null;
		this.question = null;
		this.collection = new Array<EligibilityQuestion>();
	}
}

export class EligibilityPayloadList {
	selectedCoverageEligibilityKnockouts: EligibilityPayload[];

	constructor() {
		this.selectedCoverageEligibilityKnockouts = new Array<EligibilityPayload>();
	}
}

export class EligibilityPayload {
	knockoutDependentID: string;
	isYesResponse: 'Yes' | 'No';

	constructor() {
		this.knockoutDependentID = null;
		this.isYesResponse = null;
	}
}
